import Api from "./Api";

async function getDeposit(token, params,cancelToken) {
    const headers = {
        "Authorization": `Bearer ${token}`
    }
    const response = await Api.get('/api/v1/Providers/TosanBillPayment/DepositsList', {headers, params,cancelToken});

    return response;
}

export default getDeposit;